import { shallowReactive } from 'vue';
import type { PropertyManagerSection } from './types';

const sections = shallowReactive<PropertyManagerSection[]>([]);

/**
 * 注册 PropertyManager 页面
 */
export function registerPropertyManagerSection(section: PropertyManagerSection): void {
  if (sections.find((item) => item.id === section.id)) {
    return;
  }
  sections.push(section);
  sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

/**
 * 获取已注册的页面列表（响应式）
 */
export function getPropertyManagerSections(): PropertyManagerSection[] {
  return sections;
}

